const state = {
  options: {
    target: "wallheaven",
    general: true,
    anime: true,
    people: false,
    sfw: true,
    sketchy: false,
    nsfw: false,
  },
};

export default state;
